/* PrimeChemical Corp. — capa de correcciones de contenido.
   v2 · 2026-09-15
   v1 bloqueaba la pantalla de carga: sustituia los H1 del hero (que el slider
   y el preloader tienen referenciados) y vigilaba TODO el DOM con un
   MutationObserver que se disparaba sin parar durante la animacion de carga.
   v2 no toca los H1 y solo actua cuando se abre la ventana de textos legales. */
(function () {
  'use strict';

  var TITLE = 'PrimeChemical Corp. — Creatine & Ingredient Technologies';
  var DESC = 'B2B ingredient technologies: CREAPRIME creatine monohydrate ≥ 99.9%, LACTOPRIME protein systems and SUCRAPRIME stevia sweetening. Lot analysis with every batch.';

  function seo() {
    try {
      document.title = TITLE;
      var md = document.querySelector('meta[name="description"]');
      if (md) { md.setAttribute('content', DESC); }
    } catch (e) {}
  }

  function ownLogo() {
    try {
      var url = window.PCC_PROTELLA_URL;
      if (!url) { return; }
      var imgs = document.querySelectorAll('img[src*="protella.com"]');
      for (var i = 0; i < imgs.length; i++) { imgs[i].src = url; }
    } catch (e) {}
  }

  var LEGAL = [
    ['PrimeChemical Corp. is a division of <strong>Biomediks Lab, S.L.</strong>, Calle Cobalto 9, 08907 L’Hospitalet de Llobregat (Barcelona), Spain.',
     '<strong>PrimeChemical Corp.</strong>, Calle Cobalto 9, 08907 L’Hospitalet de Llobregat (Barcelona), Spain. Company registration in progress; the VAT number will be published here once assigned.'],
    ['PrimeChemical Corp. es una división de <strong>Biomediks Lab, S.L.</strong>, Calle Cobalto 9, 08907 L’Hospitalet de Llobregat (Barcelona), España.',
     '<strong>PrimeChemical Corp.</strong>, Calle Cobalto 9, 08907 L’Hospitalet de Llobregat (Barcelona), España. Sociedad en constitución; el CIF se publicará aquí una vez asignado.'],
    ['PrimeChemical Corp. est une division de <strong>Biomediks Lab, S.L.</strong>, Calle Cobalto 9, 08907 L’Hospitalet de Llobregat (Barcelone), Espagne.',
     '<strong>PrimeChemical Corp.</strong>, Calle Cobalto 9, 08907 L’Hospitalet de Llobregat (Barcelone), Espagne. Société en cours de constitution ; le numéro de TVA sera publié ici dès son attribution.'],
    ['PrimeChemical Corp. è una divisione di <strong>Biomediks Lab, S.L.</strong>, Calle Cobalto 9, 08907 L’Hospitalet de Llobregat (Barcellona), Spagna.',
     '<strong>PrimeChemical Corp.</strong>, Calle Cobalto 9, 08907 L’Hospitalet de Llobregat (Barcellona), Spagna. Società in costituzione; la partita IVA sarà pubblicata qui una volta assegnata.'],
    ['PrimeChemical Corp. / Biomediks Lab, S.L.', 'PrimeChemical Corp.'],
    ['<strong>Biomediks Lab, S.L.</strong> (PrimeChemical Corp. division)', '<strong>PrimeChemical Corp.</strong>'],
    ['<strong>Biomediks Lab, S.L.</strong> (división PrimeChemical Corp.)', '<strong>PrimeChemical Corp.</strong>'],
    ['<strong>Biomediks Lab, S.L.</strong> (division PrimeChemical Corp.)', '<strong>PrimeChemical Corp.</strong>'],
    ['<strong>Biomediks Lab, S.L.</strong> (divisione PrimeChemical Corp.)', '<strong>PrimeChemical Corp.</strong>']
  ];

  function swap(html) {
    var out = html;
    for (var p = 0; p < LEGAL.length; p++) {
      var a = LEGAL[p][0], b = LEGAL[p][1];
      if (out.indexOf(a) > -1) { out = out.split(a).join(b); }
      var a2 = a.replace(/’/g, "'");
      if (out.indexOf(a2) > -1) { out = out.split(a2).join(b); }
    }
    if (out.indexOf('Biomediks') > -1) {
      out = out.replace(/<strong>Biomediks Lab, S\.L\.<\/strong>/g, '<strong>PrimeChemical Corp.</strong>')
               .replace(/Biomediks Lab, S\.L\./g, 'PrimeChemical Corp.');
    }
    return out;
  }

  /* Solo mira los contenedores que puedan tener el texto legal, nunca todo el DOM */
  function fixLegal() {
    try {
      var cands = document.querySelectorAll('[class*="modal"], [class*="lgl"], [id*="legal"], [class*="legal"], dialog');
      for (var i = 0; i < cands.length; i++) {
        var el = cands[i];
        if (!el.innerHTML || el.innerHTML.indexOf('Biomediks') === -1) { continue; }
        var out = swap(el.innerHTML);
        if (out !== el.innerHTML) { el.innerHTML = out; }
      }
    } catch (e) {}
  }

  function start() {
    seo();
    ownLogo();
    /* Al pulsar cualquier enlace legal, corregimos el texto justo despues de pintarlo */
    document.addEventListener('click', function (ev) {
      var t = ev.target;
      while (t && t !== document.body) {
        if (t.getAttribute && t.getAttribute('data-legal')) {
          setTimeout(fixLegal, 60);
          setTimeout(fixLegal, 400);
          return;
        }
        t = t.parentNode;
      }
    }, true);
    if (typeof window.applyLang === 'function') {
      var orig = window.applyLang;
      window.applyLang = function () {
        var r = orig.apply(this, arguments);
        setTimeout(function () { seo(); ownLogo(); fixLegal(); }, 30);
        return r;
      };
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
}());
